module.exports = __webpack_public_path__ + "img/15.ee9f6319.svg";